import { Typography } from '@mui/material';
import MuiAvatar from '@mui/material/Avatar';
import { styled } from '@mui/material/styles';

interface Properties {
  name: string;
}

const ColorAvatar = styled(MuiAvatar)({
  backgroundColor: '#3366FF',
  color: '#ffffff'
});

export default function Avatar({ name }: Properties) {
  const letter = name[0] ?? '?';
  return (
    <ColorAvatar alt={name} data-testid="avatar">
      <Typography variant="body1" mt="-2px">
        {letter}
      </Typography>
    </ColorAvatar>
  );
}
